.title {
    font-size: var(--mantine-font-size-xl);
    white-space: pre;
}

.header {
    padding: 1.5rem;
}

.scrollBar {
    color: "dark.4";
}
.fade {
    position: absolute;
    background: linear-gradient(360deg, #252b32 50%, rgba(37, 43, 50, 0) 100%);
    top: 280px;
}

.scrollRoot {
    padding-right: 0.5rem;
}

.box {
    border-radius: var(--mantine-radius-sm);
}
